import $ from 'jquery';

$('.close-bar').on('click', function() {
  $(this).parent().slideUp().removeClass('active');
  $('#pull-tab').slideDown().addClass('active');
});